export default function Footer() {
  return (
    <footer className="bg-[#0B2B4B] border-t border-[#16345C]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div>
            <div className="inline-flex rounded-xl bg-white px-4 py-2.5">
              <img src="/eyb-logo.webp" alt="EYB Consulting" className="h-8 w-auto" />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-300">
              Practical cash flow advice for Australian business owners, so you can grow with
              confidence, not crossed fingers.
            </p>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-slate-400">© 2026 EYB Consulting. All rights reserved.</p>
          <p className="font-mono-brand text-xs text-slate-500">Cash flow, finally under control.</p>
        </div>
      </div>
    </footer>
  );
}
